import './fullScreenSectionSwiper.scss';
import * as React from 'react';
import Swiper from 'react-id-swiper';
import { useSwiperSlide } from '../../hooks/useSwiperSlide';
import FullScreenSection from './fullScreenSection';
export const FullScreenSectionSwiper = (props) => {
    const { slides, swiperProps, foreground, className, darkenBg, ...HTMLAttr } = props;
    const { swiperSlide, setSwiper } = useSwiperSlide();
    return (<FullScreenSection darkenBg={darkenBg} className={`full-screen-section-swiper${className ? ` ${className}` : ''}`} background={<Swiper {...swiperProps} getSwiper={setSwiper}>
          {slides}
        </Swiper>} foreground={<>
          {!!foreground &&
        foreground(swiperSlide).map((slide, i) => React.cloneElement(slide, {
            'data-active': i === swiperSlide,
            'data-prev': i > swiperSlide,
            'data-next': i < swiperSlide,
            key: `slide${i}`,
        }))}
        </>} {...HTMLAttr}/>);
};
export default FullScreenSectionSwiper;
